import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetRefrenceWithTransactionId } from "../../../../../Utils/AllPagesQuriesAndMutations";
import Input from "../../../../Components/Input/Input";
import { TransactionInput } from "../../AddJournalVoucher/AddJournalVoucherSection/TransactionInput";
import { initialRefForNewRef } from "../../ReferenceSection/Reference.config";
import { ReferenceModal } from "../../ReferenceSection/ReferenceModal";
import "./AddBankPaymentSection.scss";
import { updateFormData } from "../../../../../Store/FormDataReducer/FormFieldFunctions";
import { IsoToDateWithoutTime } from "../../../../../CommonFunction/IsoDateTime";
import { VscReferences } from "react-icons/vsc";
const { useLazyQuery } = require("@apollo/client");

const AddPaymentSection = ({
  fielddata,
  inputfields,
  Type,
  name,
  classname,
  handleVoucherChange,
  handleAccount,
  voucher,
  Account,
  onTransactionChange,
  el,
  setData,
  index,
  VoucherData,
  InputOnFocus,
  formkey,
  TypeOfPortal,
  setFirstLoad = () => { }
}) => {
  const [transactionEntry, setTransactionEntry] = useState(el ? el : "");
  const [fields, setfields] = useState(inputfields);
  const [RefIcon, setRefIcon] = useState(false);
  const [alldata, setalldata] = useState({});
  const [Voucher_Type, setVoucher] = useState(voucher);
  const [account, setAccount] = useState(Account);
  const [modalToggle, setModalToggle] = useState(false);
  const [RefRows, setRefRows] = useState();
  const [GetReference] = useLazyQuery(GetRefrenceWithTransactionId, {
    fetchPolicy: "network-only",
  });
  const [handleRefChange, setHandleRefChange] = useState(() => (ele) => { });
  const MasterData = useSelector((store) => store?.FormDataReducer);
  // eslint-disable-next-line
  const [amount, setamount] = useState();
  useEffect(() => {
    setTimeout(() => {
      const newHandleRefChange = (elmt) => { };
      setHandleRefChange(() => newHandleRefChange);
    }, 3000);
  }, [MasterData]);
  useEffect(() => {
    if (fielddata) {
      let arr = [];
      for (var a = 0; a < fields.length; a++) {
        if (fields[a].name === "Sidebyside" || fields[a].name === "Bank details") {
          for (var b = 0; b < fields[a].Subfields.length; b++) {
            arr.push({
              [fields[a].Subfields[b].name]: fielddata[fields[a].Subfields[b].name],
            });
            formik.setFieldValue(fields[a].Subfields[b].name, fielddata[fields[a].Subfields[b].name]);
          }
        } else {
          arr.push({ [fields[a].name]: fielddata[fields[a].name] });
          formik.setFieldValue(fields[a].name, fielddata[fields[a].name]);
        }
      }
      let obj = {};
      for (var l = 0; l < arr.length; l++) {
        let temp = arr[l];
        for (var key in temp) {
          obj[key] = temp[key];
        }
      }
      if (obj) {
        setalldata(obj);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fielddata]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: "Add_FormFieldData",
      payload: { data: alldata, key: Type },
    });
    updateFormData(dispatch, formkey, Type, alldata);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alldata]);
  const validate = (values) => {
    setalldata(values);
  };
  let formik = useFormik({
    initialValues: { Date: "" },
    validate,
    onSubmit: (values) => { },
  });

  useEffect(() => {
    setfields(inputfields);
  }, [inputfields]);

  const handleVoucher = (e) => {
    setVoucher(e.target.value);
    handleVoucherChange(e);
  };
  const handleAccountChange = (e) => {
    setAccount(e.target.value);
    handleAccount(e);
  };
  const handleInputBlur = (element) => {
    let Name = element?.name;

    const page = MasterData?.MasterData[formkey];
    const AccountInfo = page && page[Name];
    if (AccountInfo?.Balance_Method === "Bill By Bill" || AccountInfo?.Balance_Method === true) {
      setModalToggle(true);
    }
    // setModalToggle(true);
  };

  useEffect(() => {
    setTransactionEntry(el);
  }, [el]);
  useEffect(() => {
    formik.setFieldValue("Account_Name", transactionEntry["Account_Name"]);
    setamount(transactionEntry["Amount"]);
    formik.setFieldValue("Amount", transactionEntry["Amount"]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionEntry]);

  useEffect(() => {
    let Name = el?.name;

    const page = MasterData?.MasterData[formkey];
    const AccountInfo = page && page[Name];
    console.log(el, typeof el.id);
    if (TypeOfPortal === "Edit" && typeof el.id === "string" && (AccountInfo?.Balance_Method === "Bill By Bill" || AccountInfo?.Balance_Method === true)) {
      GetReference({
        variables: {
          TransactionId: el.id,
        },
        fetchPolicy: "network-only",
      })
        .then((res) => {
          let updatedTransRef = {};
          // eslint-disable-next-line
          res?.data?.getRefrenceWithTransactionId?.map((el) => {
            let singleRef = initialRefForNewRef.map((item, i) => {
              console.log(item, initialRefForNewRef, i);
              if (item.name === "Particular") {
                item = { ...item, NewRef_Id: el["NewRef_Id"] };
              }
              if (item.name === "RefDate") {
                return { ...item, value: IsoToDateWithoutTime(el[item.name]) };
              }
              return {
                ...item,
                value: el[item.name],
              };
            });
            updatedTransRef = {
              ...updatedTransRef,
              [Math.random() * 10]: singleRef,
            };
          });

          setRefRows({
            [el.id]: updatedTransRef,
          });
          if (res?.data?.getRefrenceWithTransactionId?.length) {
            setRefIcon(true);
          }
        })
        .catch((err) => console.log(err.message, "error message"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [el?.id]);
  useEffect(() => {
    dispatch({ type: "tableData", payload: RefRows });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [RefRows]);
  const page = MasterData?.MasterData[formkey];
  const Account_ID = page && page[el.name]?.Account_Balance_Id;
  // const Account_ID = FormData?.masterData[el.name]?._id;
  console.log(RefIcon);
  return (
    <>
      <div key={el.id}>
        {name === "Account_Details" ? (
          <>
            <div className="paymentHeader1">
              <label className="Account_label">
                Voucher Type:&nbsp;
                <select value={Voucher_Type} onChange={(e) => handleVoucher(e)}>
                  <option value="Payment">Payment</option>
                  <option value="Receipt">Receipt</option>
                </select>
              </label>
              <label className="Account_label">
                Account Type:&nbsp;
                <select value={account} onChange={(e) => handleAccountChange(e)}>
                  <option value="Bank">Bank</option>
                  <option value="Cash">Cash</option>
                </select>
              </label>
              <div className="dateDiv">
                <Input
                  EMTQuery=""
                  checked={""}
                  InputConfig={{
                    restrictDateRange: true,
                    Reference_field: "financialYear",
                  }}
                  type="Date"
                  name="Date"
                  label="Date"
                  value={VoucherData?.Date}
                  modalform={true}
                  handleInputChange={(e) => {
                    setData(e);
                    formik.handleChange(e);
                    setFirstLoad(true)
                  }}
                  handleBlur={formik.handleBlur}
                  touched={formik.touched["Date"]}
                  error={formik.errors["Date"]}
                  dropdowndata={undefined}
                />
              </div>
            </div>
            <div className="RefAndDoc">
              <div className="">
                <Input
                  EMTQuery=""
                  checked={""}
                  InputConfig={{
                    restrictDateRange: true,
                    Reference_field: "financialYear",
                  }}
                  type="Text"
                  name="Ref_No"
                  label="Doc No"
                  value={VoucherData?.Ref_No}
                  modalform={true}
                  handleInputChange={(e) => {
                    setData(e);
                    formik.handleChange(e);
                    setFirstLoad(true)
                  }}
                  handleBlur={formik.handleBlur}
                  touched={formik.touched["Ref_No"]}
                  error={formik.errors["Ref_No"]}
                />
              </div>
              <div className="">
                <Input
                  EMTQuery=""
                  checked={""}
                  InputConfig={{
                    restrictDateRange: true,
                    Reference_field: "financialYear",
                  }}
                  type="Text"
                  name="User_Reference_Number"
                  label="User Ref No"
                  value={VoucherData?.User_Reference_Number}
                  modalform={true}
                  handleInputChange={(e) => {
                    setData(e);
                    formik.handleChange(e);
                  }}
                  handleBlur={formik.handleBlur}
                  touched={formik.touched["User_Reference_Number"]}
                  error={formik.errors["User_Reference_Number"]}
                />
              </div>
            </div>
          </>
        ) : (
          ""
        )}

        <div>
          <form autoComplete="off" className="paymentSection">
            {fields?.map((e, i) => {
              return (
                <div key={e.id} className={classname ? classname : "sectionDiv"}>
                  {i === 1 ? (
                    <TransactionInput
                      value={el["Amount"]}
                      type={"number"}
                      onTransactionChange={onTransactionChange}
                      handleInputChange={(evt) => {
                        onTransactionChange(evt, e.name, el.id);
                        // formik.handleChange(evt);

                      }}
                      onBlur={() => {
                        InputOnFocus(el, index);
                        handleInputBlur(el);
                      }}
                    />
                  ) : (
                    <Input
                      EMTQuery=""
                      checked={""}
                      InputConfig={e}
                      name={el.name}
                      id={i}
                      value={el[el.name] ? el[el.name] : ""}
                      label={e.label}
                      type={"InputDropForQuery"}
                      modalform={true}
                      Iconinside={true}
                      handleInputChange={(evt) => {
                        onTransactionChange(evt, el.name, el.id);
                        // formik.handleChange(evt);
                        // handleRefChange(evt);
                        handleRefChange(el);
                      }}
                      dropdowndata={i === 0 ? e.dropdowndata : ""}
                      hasApiCallback={e.hasApiCallback}
                      handleBlur={formik.handleBlur}
                      touched={formik.touched[e.name]}
                      error={formik.errors[e.name]}
                      max={e.max}
                      transactions={true}
                      formkey={formkey}
                    />
                  )}
                  {i === 1 ? (
                    transactionEntry.Transaction_Type === "Credit" ? (
                      <>
                        {" "}
                        <span className={"Cr"}>
                          Cr
                          {RefIcon && <VscReferences onClick={() => handleInputBlur(el)} className="ReferenceIcon" />}
                        </span>
                        {/* {RefIcon && (
                          <span className="ReferenceIcon">
                            <VscReferences />
                          </span>
                        )} */}
                      </>
                    ) : (
                      <>
                        {" "}
                        <span className={"Db"}>
                          Dr
                          {RefIcon && <VscReferences onClick={() => handleInputBlur(el)} className="ReferenceIcon" />}
                        </span>
                        {/* {RefIcon && (
                          <span className="ReferenceIcon">
                            <VscReferences />
                          </span>
                        )} */}
                      </>
                    )
                  ) : (
                    ""
                  )}
                </div>
              );
            })}
          </form>
        </div>
      </div>
      <>
        {modalToggle ? (
          <ReferenceModal
            Amount={Number(el.Amount)}
            transactionId={el.id}
            setModalToggle={() => setModalToggle(false)}
            show={modalToggle}
            Account_ID={Account_ID}
            Transaction_Type={el.Transaction_Type}
          />
        ) : (
          ""
        )}
      </>
    </>
  );
};

export default AddPaymentSection;
